import script from "./SessionVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionVideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./SessionVideoPlayer.vue?vue&type=style&index=0&id=a7998414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7998414"]])

export default __exports__